import { API_PREFIX } from "app/constants";
import to from "core/util/fetch/awaitToJs";
import superagent from "superagent";

const URL_PREFIX = `${API_PREFIX}/campaign`;

const getElectronicCommunicationData = async (guid: string, idObject: number) => {
    return await to(superagent.get(`${URL_PREFIX}/electronic-communication/${guid}/${idObject}`));
};

const getElectronicCommunicationEmailFromClient360Data = async (guid: string, idObject: number) => {
    return await to(superagent.get(`${URL_PREFIX}/electronic-communication-client360-email/${guid}/${idObject}`));
};

const setElectronicCommunication = async (data) => {
    return await to(
        superagent.put(`${URL_PREFIX}/electronic-communication`).send(data).set("Content-Type", "application/json").accept("json"),
    );
};

export default {
    getElectronicCommunicationData,
    getElectronicCommunicationEmailFromClient360Data,
    setElectronicCommunication,
};
